import React, { useMemo } from 'react';
import { ConfigProvider } from 'antd';
import esES from 'antd/lib/locale/es_ES';
import enUS from 'antd/lib/locale/en_US';
import { useTranslation } from 'react-i18next';

const theme = {
  token: {
    colorPrimary: '#003270',
    fontFamily: 'Poppins, sans-serif',
  },
};

const AppProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { i18n } = useTranslation();

  const antdLocale = useMemo(() => {
    return i18n.language.startsWith('en') ? enUS : esES;
  }, [i18n.language]);

  return (
    <ConfigProvider locale={antdLocale} theme={theme}>
      {children}
    </ConfigProvider>
  );
};

export default AppProviders;
